import React from 'react'

import {SaveButton, SaveInput, SaveControlsWrapper} from './SaveFilterDialog.styles'

import Typestack from '../../../typestack'

const SaveFilterDialogComponent = ({events, filterName, i18n}) => {
  return (
    <div>
      <Typestack type='heading' size='lg' weight='black'>{i18n.saveFilters}</Typestack>
      <p>
        {i18n.pleaseName}
      </p>

      <SaveControlsWrapper>
        <SaveInput type='text' onChange={events.handleChange} placeholder='Name...' value={filterName} />

        <SaveButton href='/' onClick={events.handleSaveClick}>{i18n.save}</SaveButton>

        <p>
          <a href='/' onClick={events.handleCancelClick}>{i18n.continueWithoutSaving}</a>
        </p>
      </SaveControlsWrapper>
    </div>
  )
}

export default SaveFilterDialogComponent
